import * as React from 'react';

import { CmsTranslation } from './types';

export const defaultTranslationStore = {};

export const TranslationContext = React.createContext<CmsTranslation>(defaultTranslationStore);
TranslationContext.displayName = 'TranslationContext';
